import Vue from 'vue'
import Router from 'vue-router'
import menu from './menu'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...menu.initial(),
  ],
})

export default router
